import {useEffect, useState} from 'react';
import { motion } from 'framer-motion';
import {useDispatch} from 'react-redux';
import {popupClick, popupClose} from '../../../reducers/popups/actions';
import {navigate} from '../../../utils/navigation';

export default ({
    id,
    type,
    details,
    action
}) => {
    const [showed, setShowed] = useState(false),
          dispatch = useDispatch();

    useEffect(() => {
        if(typeof window.popups === 'undefined')
            window.popups = {};

        return () => clearTimeout(window.popups[id]);
    }, []);

    const closeAction = () => dispatch(popupClose(id));
    const clickAction = () => {
        dispatch(popupClick(id));

        if(action.type === 'navigate')
            navigate(action.path);
    }

    useEffect(() => {
        if(!showed) {
            setTimeout(setShowed, 50, true);
        } else {
            window.popups[id] = setTimeout(closeAction, 7e3);
        }
    }, [showed]);

    return (
        <motion.div 
            className={`popup ${type}`}
            key={id}
            initial={{ x: '120%', opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: '120%', opacity: 0 }}
            transition={{
                duration: 0.3,
                ease: [0.22, 1, 0.36, 1]
            }}
            onClick={e => clickAction()}
            >
            <div className="border"></div>
            <div className="popup-content">
                <div className="popup-details">
                    <div className="image">
                        <img src={`${window.location.origin}/source/system/popups/${type}.png`} alt="Popup Image" />
                    </div>
                    <div className="details">
                        <div className="title">
                            {details.title}

                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.0069 9.7159V3.99305H6.28408" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M3.99308 12.0069L11.9268 4.07318" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                        <div className="text" dangerouslySetInnerHTML={{__html: details.text}}></div>
                    </div>
                </div>
                <div className="popup-progress">
                    <div className="popup-progress-value" style={{width: `${showed ? '100%' : '0%'}`}}></div>
                </div>
            </div>
        </motion.div>
    )
}